import { render, staticRenderFns } from "./MaisIndicadores.vue?vue&type=template&id=0b1c2718"
import script from "./MaisIndicadores.vue?vue&type=script&lang=js"
export * from "./MaisIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports